export const POST_PAYMENT_METHOD = 'POST_PAYMENT_METHOD';
export const generatePostPaymentMethodFocusKey = (index: number) =>
  `${POST_PAYMENT_METHOD}_${index}`;
export const POST_PAYMENT_METHOD_FIRST = generatePostPaymentMethodFocusKey(0);
export const POST_PAYMENT_METHOD_NEW = `${POST_PAYMENT_METHOD}_NEW`;
